export default __webpack_public_path__ + "static/media/delete.9cbc15e1.svg";